function errorText(error: unknown): string {
  if (!(error instanceof Error)) return ''
  return error.message
}

/**
 * Production hides the server exception behind React error #441. The server
 * already reports that failure, so the client boundary must not send it again.
 */
export function isServerComponentRenderError(error: unknown): boolean {
  const text = errorText(error)
  if (text.length === 0) return false
  return (
    /Minified React error #441\b/.test(text) ||
    text.includes('An error occurred in the Server Components render')
  )
}
